import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import About from '../About'
import Benefits from '../Benefits'
import DNK from '../DNK'
import EndBlock from '../EndBlock'
import Focus from '../Focus'
import Intro from '../Intro'
import Vacancies from '../Vacancies'

const CareerContent = observer(() => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    })
  }, [])

  useEffect(() => {
    setTimeout(() => {
      let vh = window.innerHeight * 0.01
      ;(document.querySelector(
        '.intro-career',
      ) as HTMLElement).style.setProperty('--vh', `${vh}px`)
    }, 100)
  }, [width, height])

  return (
    <section className="career-content">
      <Intro />
      <About />
      <Vacancies />
      <Benefits />
      <DNK />
      <Focus />
      <EndBlock />
    </section>
  )
})

export default CareerContent
